import React from "react";
import { Tabs, Tab } from "react-bootstrap";
import ModelComparisonPage from "./ModelComparisonPage";
import DocumentAnalysisPage from "./DocumentAnalysisPage";
import EntityAnalysisPage from "./EntityAnalysisPage";

const AnalyticsDashboard: React.FC = () => {
  return (
    <div>
      <h1 className="mb-4">Redaction Intelligence Dashboard</h1>
      <Tabs defaultActiveKey="model-comparison" id="analytics-tabs">
        <Tab eventKey="model-comparison" title="Model Comparison">
          <ModelComparisonPage />
        </Tab>
        <Tab eventKey="document-analysis" title="Document Analysis">
          <DocumentAnalysisPage />
        </Tab>
        <Tab eventKey="entity-analysis" title="Entity Analysis">
          <EntityAnalysisPage />
        </Tab>
      </Tabs>
    </div>
  );
};

export default AnalyticsDashboard;
